import { SagaIterator } from 'redux-saga';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import * as divisionService from '../../services/divisionAPI';
import { fetchDivisionListFailure, fetchDivisionListSuccess } from './actions';
import { FETCH_DIVISION_LIST_REQUEST } from './actionTypes';
import { IFetchDivisionListRequest } from './types';
import { userTenantIdSelector } from '../user/selectors';

export function* fetchDivisionListSagaRequest({
  countryId,
  successCb,
  failureCb
}: IFetchDivisionListRequest): SagaIterator {
  try {
    const userTenantId = yield select(userTenantIdSelector);
    const {
      data: { entityList: list, totalCount: total }
    } = yield call(divisionService.fetchDivisionList as any, countryId, userTenantId);
    const payload = { divisionList: list, total };
    successCb?.(payload);
    yield put(fetchDivisionListSuccess(payload));
  } catch (e) {
    if (e instanceof Error) {
      failureCb?.(e);
      yield put(fetchDivisionListFailure(e));
    }
  }
}

function* divisionSaga() {
  yield all([takeLatest(FETCH_DIVISION_LIST_REQUEST, fetchDivisionListSagaRequest)]);
}

export default divisionSaga;
